// extracted by mini-css-extract-plugin
module.exports = {"browser":"FakeBrowser_browser__bUHXK"};